/**
 * Component tokens index
 *
 * Exports all component-specific token customisations.
 * Component tokens map to semantic tokens (not primitives directly).
 *
 * @see https://primeng.org/theming#component-tokens
 */
import { accordionComponentTokens } from './accordion';
import { badgeComponentTokens } from './badge';
import { breadcrumbComponentTokens } from './breadcrumb';
import { buttonComponentTokens } from './button';
import { cardComponentTokens } from './card';
import { checkboxComponentTokens } from './checkbox';
import { datepickerComponentTokens } from './datepicker';
import { listboxComponentTokens } from './listbox';
import { multiselectComponentTokens } from './multiselect';
import { menuComponentTokens } from './menu';
import { menubarComponentTokens } from './menubar';
import { paginatorComponentTokens } from './paginator';
import { panelmenuComponentTokens } from './panelmenu';
import { selectComponentTokens } from './select';
import { stepperComponentTokens } from './stepper';
import { tabsComponentTokens } from './tabs';
import { treeComponentTokens } from './tree';
import { datatableComponentTokens } from './datatable';
import { dividerComponentTokens } from './divider';
import { fieldsetComponentTokens } from './fieldset';
import { tagComponentTokens } from './tag';
import { messageComponentTokens } from './message';
import { toastComponentTokens } from './toast';

export { accordionComponentTokens } from './accordion';
export { badgeComponentTokens } from './badge';
export { breadcrumbComponentTokens } from './breadcrumb';
export { buttonComponentTokens } from './button';
export { cardComponentTokens } from './card';
export { checkboxComponentTokens } from './checkbox';
export { datepickerComponentTokens } from './datepicker';
export { listboxComponentTokens } from './listbox';
export { multiselectComponentTokens } from './multiselect';
export { menuComponentTokens } from './menu';
export { menubarComponentTokens } from './menubar';
export { paginatorComponentTokens } from './paginator';
export { panelmenuComponentTokens } from './panelmenu';
export { selectComponentTokens } from './select';
export { stepperComponentTokens } from './stepper';
export { tabsComponentTokens } from './tabs';
export { treeComponentTokens } from './tree';
export { datatableComponentTokens } from './datatable';
export { dividerComponentTokens } from './divider';
export { fieldsetComponentTokens } from './fieldset';
export { tagComponentTokens } from './tag';
export { messageComponentTokens } from './message';
export { toastComponentTokens } from './toast';

// Export types
export type {
  AccordionDesignTokens,
  AccordionTokenSections,
  BadgeDesignTokens,
  BadgeTokenSections,
  BreadcrumbDesignTokens,
  BreadcrumbTokenSections,
  ButtonDesignTokens,
  ButtonTokenSections,
  CheckboxDesignTokens,
  CheckboxTokenSections,
  DatePickerDesignTokens,
  DatePickerTokenSections,
  ListboxDesignTokens,
  ListboxTokenSections,
  MultiSelectDesignTokens,
  MultiSelectTokenSections,
  MenubarDesignTokens,
  MenubarTokenSections,
  MenuDesignTokens,
  MenuTokenSections,
  PaginatorDesignTokens,
  PaginatorTokenSections,
  PanelMenuDesignTokens,
  PanelMenuTokenSections,
  SelectDesignTokens,
  SelectTokenSections,
  StepperDesignTokens,
  StepperTokenSections,
  TabsDesignTokens,
  TabsTokenSections,
  TreeDesignTokens,
  TreeTokenSections,
  DataTableDesignTokens,
  DataTableTokenSections,
  DividerDesignTokens,
  DividerTokenSections,
  FieldsetDesignTokens,
  FieldsetTokenSections,
  TagDesignTokens,
  TagTokenSections,
  MessageDesignTokens,
  MessageTokenSections,
  ToastDesignTokens,
  ToastTokenSections,
} from './types';

/**
 * Combined component tokens
 * All component token customisations merged together
 */
export const componentTokens = {
  accordion: accordionComponentTokens,
  badge: badgeComponentTokens,
  breadcrumb: breadcrumbComponentTokens,
  button: buttonComponentTokens,
  card: cardComponentTokens,
  checkbox: checkboxComponentTokens,
  datepicker: datepickerComponentTokens,
  menu: menuComponentTokens,
  menubar: menubarComponentTokens,
  paginator: paginatorComponentTokens,
  panelmenu: panelmenuComponentTokens,
  select: selectComponentTokens,
  stepper: stepperComponentTokens,
  tabs: tabsComponentTokens,
  listbox: listboxComponentTokens,
  multiselect: multiselectComponentTokens,
  tree: treeComponentTokens,
  datatable: datatableComponentTokens,
  divider: dividerComponentTokens,
  fieldset: fieldsetComponentTokens,
  tag: tagComponentTokens,
  message: messageComponentTokens,
  toast: toastComponentTokens,
};
